import { useCallback } from "react";

import { AlertColor } from "@mui/material";

import { useSnackbarContext } from "../components/EnhancedSnackbar/context";

export const useSnackbar = () => {
  const setSnackbarState = useSnackbarContext();

  const showSnackbar = useCallback(
    (type: AlertColor, message: string, action?: React.ReactNode[], autoHideDuration?: number) => {
      setSnackbarState({
        type,
        action,
        message,
        open: true,
        autoHideDuration,
      });
    },
    []
  );

  const closeSnackbar = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const showErrorSnackbar = useCallback(
    (message = "An error occurred. Please try again later", action?: React.ReactNode[], autoHideDuration?: number) => {
      return showSnackbar("error", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  const showSuccessSnackbar = useCallback(
    (message: string, action?: React.ReactNode[], autoHideDuration?: number) => {
      return showSnackbar("success", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  const showInfoSnackbar = useCallback(
    (message: string, action?: React.ReactNode[], autoHideDuration?: number) => {
      return showSnackbar("info", message, action, autoHideDuration);
    },
    [showSnackbar]
  );

  return {
    showInfoSnackbar,
    showErrorSnackbar,
    showSuccessSnackbar,
    closeSnackbar,
  };
};
